import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";

var flattenSubject = function flattenSubject(subject) {
  var ind = subject.indirectSubjects || [];

  var ns = _extends({}, subject, {
    indirectSubjects: undefined
  });

  return [ns].concat(_toConsumableArray(ind));
};

var flattenSubjectArr = function flattenSubjectArr(subjects) {
  return subjects.map(flattenSubject).reduce(function (a, s) {
    return [].concat(_toConsumableArray(a), _toConsumableArray(s));
  }, []);
};

export default function flattenCartContent(cart) {
  return [].concat(_toConsumableArray(flattenSubjectArr(cart.subjects)), _toConsumableArray(flattenSubject(cart.payment)), _toConsumableArray(flattenSubject(cart.shipping)), _toConsumableArray(cart.indirectSubjects || []));
}